import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentProductPricesHistoriesProps<T> = {
  id?: string;
  enabled?: boolean;
  filters?: {
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useEstablishmentProductPricesHistories = <T,>({
  id,
  enabled = false,
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentProductPricesHistoriesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta} = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    enabled,
    queryKey: ['establishmentProductPricesHistories', id, page],
    queryFn: () => {
      return privateAxios.get(`/establishment/product_prices/${id}/histories`, {
        params: {
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending,  ...rest };
};
